export default {
  replaysSessionSampleRate: 0,
  tracesSampleRate: 0,
}
